/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GasStationClaimRequest
 */
export interface GasStationClaimRequest {
    /**
     * Board space position where gas station is located
     * @type {number}
     * @memberof GasStationClaimRequest
     */
    spacePosition: number;
    /**
     * Timestamp when user landed on gas station (for validity window)
     * @type {Date}
     * @memberof GasStationClaimRequest
     */
    landedAt: Date;
}

/**
 * Check if a given object implements the GasStationClaimRequest interface.
 */
export function instanceOfGasStationClaimRequest(value: object): value is GasStationClaimRequest {
    if (!('spacePosition' in value) || value['spacePosition'] === undefined) return false;
    if (!('landedAt' in value) || value['landedAt'] === undefined) return false;
    return true;
}

export function GasStationClaimRequestFromJSON(json: any): GasStationClaimRequest {
    return GasStationClaimRequestFromJSONTyped(json, false);
}

export function GasStationClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GasStationClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'spacePosition': json['spacePosition'],
        'landedAt': (new Date(json['landedAt'])),
    };
}

export function GasStationClaimRequestToJSON(json: any): GasStationClaimRequest {
    return GasStationClaimRequestToJSONTyped(json, false);
}

export function GasStationClaimRequestToJSONTyped(value?: GasStationClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spacePosition': value['spacePosition'],
        'landedAt': ((value['landedAt']).toISOString()),
    };
}

